<template lang="pug">
  .q-pa-md.q-gutter-y-sm
    navbar(back="collection-list")
    .row
      .offset-md-2.col-md-8.offset-sm-1.col-sm-10.q-gutter-md
        h6 Administrace
        q-separator.q-my-md(inset)
        div.row.q-gutter-lg.justify-center
          q-card.col.col-sm-12.col-md-6(bordered flat)
            q-card-section
              q-btn.fit(color="primary" flat :to="{name: 'administration-taxonomy-list'}") Taxonomie
          q-card.col.col-sm-12.col-md-6(bordered flat)
            q-card-section
              q-btn.fit(color="primary" flat :to="{name: 'administration-reports'}") Reporty
</template>
<style lang="stylus">
  h6
    margin-top 32px
    margin-bottom 16px
</style>

<script>
import { Component, Vue } from 'vue-property-decorator'
import Navbar from '../components/Navbar'

export default @Component({
  meta: {
    title: '- Administrace'
  },
  components: {
    'navbar': Navbar
  }
})
class AdministrationHomePage extends Vue {
}
</script>
